
// make sure the document is loaded first
$(document).ready( function(evt){

    // on click of the checkbox
    $('.faux-tickbox.kiwisaver-terms-and-conditions').on('click', function(evt){
        $(this).toggleClass('checked');
        checkKiwisaverButtonVisibility();
    });    
    
    // on click of button, make sure we're not disabled
    $(document).on('click', '.kiwisaver-button.disabled', function(evt){
        evt.preventDefault();
        alert('You need to agree to the Terms and Conditions first');
    });

});


/*
 * Check the visibility of the Kiwisaver buttons
 * No agreement, then disable buttons
*/
function checkKiwisaverButtonVisibility(){
    
    if( $('.faux-tickbox.kiwisaver-terms-and-conditions').hasClass('checked') ){
        $('.kiwisaver-button').removeClass('disabled');
    }else{
        $('.kiwisaver-button').addClass('disabled');
    }
    
}